/* eslint-disable @typescript-eslint/no-unused-vars */
import { UserRole } from "@/types";
import { jwtDecode } from "jwt-decode";

export const decode = (token: string) => {
  try {
    const data = jwtDecode(token);
    return data;
  } catch (error) {
    return null;
  }
};
export const getUseRoute = (role: UserRole) => {
  switch (role) {
    case UserRole.ADMIN:
      return "/licencing-admin";
    case UserRole.ADMINCOUNCIL:
      return "/licencing-admin";
    case UserRole.VERIFIER:
      return "/approvalofficesaccount";
    case UserRole.FIRSTREVIEWER:
      return "/approvalofficesaccount";
    case UserRole.SECONDREVIEWER:
      return "/approvalofficesaccount";
    case UserRole.APPROVER:
      return "/approvalofficesaccount";
    case UserRole.ENDUSER:
      return "/end-user-account";
    case UserRole.INVIGILATOR:
      return "/invigilator-account";
    case UserRole.EXAMINER:
      return "/examiner-account";
    default:
      return "/";
  }
};
